var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMauritania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13761_68376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 -0.00256348H0V15.9949H24V-0.00256348Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.49606C10.8073 9.49716 9.64962 9.17911 8.71764 8.5943C7.78566 8.00948 7.1349 7.19275 6.8725 6.27856C6.79433 6.56097 6.75328 6.84894 6.75 7.13794C6.75 8.23196 7.30312 9.28117 8.28769 10.0548C9.27226 10.8283 10.6076 11.2629 12 11.2629C13.3924 11.2629 14.7277 10.8283 15.7123 10.0548C16.6969 9.28117 17.25 8.23196 17.25 7.13794C17.2467 6.84894 17.2057 6.56097 17.1275 6.27856C16.8651 7.19275 16.2143 8.00948 15.2824 8.5943C14.3504 9.17911 13.1927 9.49716 12 9.49606Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0032 4.625L12.3584 5.71591H13.5L12.574 6.38821L12.9292 7.47912L12.0032 6.80682L11.0772 7.47912L11.4323 6.38821L10.5 5.71591H11.648L12.0032 4.625Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 -0.00256348H0V2.99744H24V-0.00256348Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12.995H0V15.995H24V12.995Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13761_68376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMauritania);
export default __webpack_public_path__ + "static/media/Mauritania.7976b82ce698f0470dc5a8c1960ba8b4.svg";
export { ForwardRef as ReactComponent };